import { render, staticRenderFns } from "./FuzzyList.vue?vue&type=template&id=2185e0d4"
import script from "./FuzzyList.vue?vue&type=script&lang=js"
export * from "./FuzzyList.vue?vue&type=script&lang=js"
import style0 from "./FuzzyList.vue?vue&type=style&index=0&id=2185e0d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports